module.exports = __webpack_public_path__ + "static/media/icon-geomapa.8c52972d.webp";